// extracted by mini-css-extract-plugin
export default {"catCard":"CatCard_catCard__dYSnS","images":"CatCard_images__IKTFA","name":"CatCard_name__Cv3u1","btn":"CatCard_btn__Pb8+x","admin":"CatCard_admin__92c7i"};